export const LOADING_ON = "LOADING_ON";
export type LOADING_ON = "LOADING_ON";

export const LOADING_OFF = "LOADING_OFF";
export type LOADING_OFF = "LOADING_OFF";

// export const LOADING_FALSE = "LOADING_FALSE";
// export type LOADING_FALSE = "LOADING_FALSE";
